<template>
    <tr class="convention-ca-territory-item">
        <td>
            <typo name="cc-body">{{ item.code }}</typo>
        </td>
        <td>
            <typo name="cc-body">{{ territories[item.code].label }}</typo>
            <convention-body v-if="item.description" :body="item.description" />
            <typo name="cc-body" v-if="item.isExcluded">(exclu)</typo>
        </td>
    </tr>
</template>

<script>
import ConventionBody from "src/components/convention/ConventionBody.vue";

export default {
    components: { ConventionBody },
    props: ["item", "territories"],
};
</script>

<style scoped lang="sass">
.convention-body
    font-style: italic !important
</style>
